export default {
  'Header.Header.Cell': ({ orderBy, orderDirection, content }, outlet) => {
    if (content.sortingField !== orderBy) {
      outlet({ orderDirection: 'asc', orderBy: content.sortingField });
    } else if (orderDirection === 'asc') {
      outlet({ orderDirection: 'desc' });
    } else {
      outlet({ orderDirection: '', orderBy: '' });
    }
  }
};
